import { createSlice } from "@reduxjs/toolkit";

const siteSlice = createSlice({
    name:"sites",
    initialState:{
        isLoading:true,
        miningSites:[]
    },
    reducers:{
        setSites:(state, action)=>{
            state.miningSites = action.payload;
            state.isLoading = false;
            return state;
        }
    }
})

export const {setSites} = siteSlice.actions;
export default siteSlice.reducer;